import React from "react";
import { string, bool, object, array } from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import { connect } from "react-redux";

import CardImage from "../CardImage";
import Icon from "../../icons";
import NewsHeadline from "../NewsHeadline";

import { getStoryData } from "../../utils/utils";

import "./focusedCard.m.css";

const FocusedCard = ({
  story,
  className = "",
  cardWithImageZoom = true,
  showSection = true,
  aspectRatio = [2, 3],
  imageType = "image2x3",
  showTag = false,
  sketchesHost,
}) => {
  const storyData = getStoryData(story);

  if (!storyData.headline || !story.url) {
    return null;
  }

  const section = get(story, ["sections", "0"], null);
  const tag = get(story, ["tags", "0"], null);

  const getMetaInfo = () => {
    if (showTag && tag) {
      return (
        <Link aria-label={tag.name} href={`${sketchesHost}/topic/${tag.slug}`}>
          <div styleName="section-name">{tag.name}</div>
        </Link>
      );
    } else if (showSection && section) {
      return (
        <Link aria-label={section["display-name"] || section.name} href={section["section-url"]}>
          <div styleName="section-name">{section["display-name"] || section.name}</div>
        </Link>
      );
    } else return null;
  };

  return (
    <div
      aria-label={`${"Read full story: "} ${storyData.headline}`}
      className={`${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""} focused-card`}
    >
      <div styleName="base">
        <Link aria-label={story.headline} href={story.url}>
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={[350]}
            showAlternateImage={true}
          />
        </Link>
        {getMetaInfo()}
        <div styleName="text-wrapper">
          <span className="story-type-wrapper">
            {story["story-template"] === "video" && <Icon type="video-whitebg" className="video-whitebg" />}
            {story["story-template"] === "photo" && <Icon type="gallery-whitebg" className="gallery-whitebg" />}
          </span>
          <NewsHeadline story={story} cssStyleName="mediumBigSize" />
        </div>
      </div>
    </div>
  );
};

FocusedCard.propTypes = {
  className: string,
  cardWithImageZoom: bool,
  story: object,
  showSection: bool,
  imageType: string,
  showTag: bool,
  sketchesHost: string,
  aspectRatio: array,
};

const mapStateToProps = (state) => ({
  sketchesHost: get(state, ["qt", "config", "sketches-host"]),
});

export default connect(mapStateToProps, null)(FocusedCard);
